import React from "react";
import useStore from "../store";
import strings from "../lang/Localiz";

function MoveBeetween() {
  const locator = useStore((state) => state.locator);
  const dice = useStore((state) => state.dice);

  return (
    <div className={"hud-move-beetween"}>
      {locator && (
        <div className={"hud-bones-rolls-beetween"}>
          <span>{dice > 0 ? "+" + dice : dice}</span>
          <div className={"beetween-container"}>
            <div className={"rolls-beetween-zgl"}>
              {dice > 0
                ? strings.diceText.forward.title
                : strings.diceText.back.title}
            </div>
            <div className={"rolls-beetween-txt"}>
              {dice > 0
                ? strings.diceText.forward.description
                : strings.diceText.back.description}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MoveBeetween;
